import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MdDialogRef, MdSnackBar} from '@angular/material';
import {AgrisService, HttpClient} from '../../../../services';
import {
  InsumoPrincipioActivoViewModel,
  InsumosViewModel, OficinaComercialViewModel, SucursalComercialViewModel
} from '../../common/AgrisViewModels';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'app-agris-insert-insum-cotiz-dialog',
  templateUrl: './agris-insert-insum-cotiz-dialog.component.html',
  styleUrls: ['./agris-insert-insum-cotiz-dialog.component.scss', '../../common/agris-common-styles.scss']
})
export class AgrisInsertInsumCotizDialogComponent implements OnInit, OnDestroy {

  insumos: InsumoToAdd[] = [];
  searchTerm = '';
  sub: Subscription[] = [];

  selectedInsumos = false;

  loading = false;

  public oficina = 0;
  public sucursal = 0;

  @HostListener('document:keydown.enter', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.onSearch();
  }

  constructor(
    public dialogRef: MdDialogRef<AgrisInsertInsumCotizDialogComponent>,
    private httpService: HttpClient,
    private agrisService: AgrisService,
    private snackBar: MdSnackBar
  ) {}

  ngOnInit() {  }

  ngOnDestroy() {
    this.sub.forEach(x => x.unsubscribe());
  }

  onSearch() {
    if (!this.searchTerm.length) {return;}
    if (this.oficina === null || this.sucursal === null) {
      this.snackBar.open('Ha ocurrido un error al obtener la busqueda, por favor intente nuevamente', null, {duration: 3000});
      return;
    }
    const payload: InsumosViewModel = {
      IdOficina: this.oficina,
      IdSucursal: this.sucursal,
      filter: this.searchTerm,
      filterFamilia: '',
      filterLinea: '',
      filterRubro: '',
      filterSubRubro: '',
      listaInsumos: []
    }
    this.loading = true;
    this.sub.push(
      this.agrisService.searchInsumos(payload).subscribe(x => {
        this.insumos = x !== null ? x.listaInsumos.map(x => ({...x, selected: false})) : [];
        this.insumos.sort((a, b) => {
          return (a.ProductoBandera - b.ProductoBandera) * -1; // POR DEFECTO: Ordenamiento descendente por Bandera
        });
        this.loading = false;
      }, () => {
        this.loading = false;
        this.agrisService.showSnackbarAPIError();
      })
    );
  }

  onSelected(insumo: InsumoToAdd) {
    insumo.selected = !insumo.selected;
    this.selectedInsumos = this.insumos.some(x => x.selected);
  }

  onSubmit() {
    this.dialogRef.close(this.insumos.filter(x => x.selected));
  }

}

interface InsumoToAdd {
  Nombre: string;
  Descripcion: string;
  UnidadMedida: string;
  RN1Central: number;
  RN2Propias: number;
  RN2Agroinsumos: number;
  RN2OtrosAcopios: number;
  RN3Propias: number;
  CodigoRubro: string;
  DescripcionRubro: string;
  CodigoSubRubro: string;
  DescripcionSubRubro: string;
  CodigoFamilia: string;
  DescripcionFamilia: string;
  CodigoLinea: string;
  DescripcionLinea: string;
  CodigoProveedor: string;
  DescripcionProveedor: string;
  PrecioPublico: number;
  PrecioMinimo: number;
  PorcentajeDescMax: number;
  DosisPorHectarea: number;
  ImporteDosis: number;
  DiasResidualidad: number;
  CostoDiario: number;
  TrmRN2: number;
  Margen: number;
  TrmRN1: number;
  ConsumoAnterior: number;
  ConsumoAnteriorHoy: number;
  ConsumoActual: number;
  ProductoBandera: number;
  PrincipioActivo: InsumoPrincipioActivoViewModel[];
  selected: boolean;
}




// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-cotizacion-detalle-page/agris-insert-insum-cotiz-dialog/agris-insert-insum-cotiz-dialog.component.ts